import { render } from "./ChatbotDropdown.vue?vue&type=template&id=f656c4ea&scoped=true"
import script from "./ChatbotDropdown.vue?vue&type=script&lang=js"
export * from "./ChatbotDropdown.vue?vue&type=script&lang=js"

import "./ChatbotDropdown.vue?vue&type=style&index=0&id=f656c4ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f656c4ea"]])

export default __exports__